import React, { useState, useEffect } from 'react';
import { useHistory, useParams, Link as RouterLink } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
    useMediaQuery, Grid, Button, Fab, TextField, Container, List, ListSubheader, ListItem, ListItemIcon, ListItemText, ListItemSecondaryAction,
    FormControl, FormLabel, FormGroup, FormControlLabel, FormHelperText, Checkbox,
    IconButton, Typography, Breadcrumbs, Link, Divider, Paper, TableContainer, Table, TableHead, TableBody, TableRow, TableCell,
    Drawer, TablePagination, InputLabel, Input, InputAdornment
} from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { Alert, Pagination } from '@material-ui/lab';
import { Edit as EditIcon, FilterList as FilterListIcon, Search as SearchIcon, Close as CloseIcon } from '@material-ui/icons';
import { getTransactions, updateDisplayTransactions } from '../../actions/managementAlarmSystemTransactions';
import * as constants from '../../constants';
import useUser from '../../user/useUser';
import TableViewTransactions from './TableViewTransactions';

const ManagementAlarmSystemTransactions = () => {

    const dispatch = useDispatch();
    const { id } = useParams();

    const loading = useSelector(state => state.global.loading);
    const transactions = useSelector(state => state.managementAlarmSystemTransactions.transactions);
    const alarmSystem = useSelector(state => state.managementAlarmSystemTransactions.alarmSystem);
    const license = useSelector(state => state.managementAlarmSystemTransactions.license);
    const displayTransactions = useSelector(state => state.managementAlarmSystemTransactions.displayTransactions);
    const generalErrorText = useSelector(state => state.managementAlarmSystemTransactions.generalErrorText);

    const { token, unsetUser } = useUser();
    const { t, i18n } = useTranslation();
    const history = useHistory();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const language = i18n.languages[0];

    useEffect(() => {
        dispatch(getTransactions(id, displayTransactions.searchText, displayTransactions.sort, displayTransactions.transactionId, history, token, unsetUser, t, language));
    }, [id, token]);


    //const notificationTypeLookup = Object.assign({}, constants.NOTIFICATION_TYPES.map(n => ({ [n.type]: t(`MonitoringType${n.name}`) })));


    return (
        <React.Fragment>
            <Container>
                <Breadcrumbs style={{ marginTop: 20 }}>
                    <Link color="inherit" component={RouterLink} to={constants.ROUTE_MANAGEMENT}>{t("Management")}</Link>
                    <Link color="inherit" component={RouterLink} to={constants.ROUTE_MANAGEMENT_ALARM_SYSTEMS}>{t("AlarmSystems")}</Link>
                    {alarmSystem ? <Typography color="textPrimary">{alarmSystem.mac}</Typography> : null}
                    <Typography color="textPrimary">{t("Transactions")}</Typography>
                </Breadcrumbs>
                <Divider style={{ marginTop: 10, marginBottom: 10 }} />

                {generalErrorText ? <Alert style={{ marginTop: 10 }} severity="error">{generalErrorText}</Alert> : null}
            </Container>

            <Container style={{ marginTop: 10 }} maxWidth={false}>
                <Paper style={{ maxWidth: '100%', padding: 5 }}>

                    <div style={{ display: "flex", flexGrow: 1, justifyContent: "space-between", alignItems: "stretch" }}>
                        <div style={{ flexGrow: 0 }}>

                        </div>
                        <div style={{ width: 150, flexGrow: 0 }}>
                            <FormControl>
                                <Input
                                    startAdornment={
                                        <InputAdornment position="start">
                                            <SearchIcon />
                                        </InputAdornment>
                                    }
                                    endAdornment={displayTransactions.searchText ?
                                        <InputAdornment position="end">
                                            <IconButton onClick={() => dispatch(updateDisplayTransactions(transactions, '', displayTransactions.sort, displayTransactions.transactionId, t))}>
                                                <CloseIcon />
                                            </IconButton>
                                        </InputAdornment> :
                                        null
                                    }
                                    value={displayTransactions.searchText}
                                    onChange={event => dispatch(updateDisplayTransactions(transactions, event.target.value, displayTransactions.sort, displayTransactions.transactionId, t))}
                                />
                            </FormControl>
                        </div>
                    </div>

                    <TableViewTransactions />
                </Paper>
            </Container>

        </React.Fragment>
    );
}

export default ManagementAlarmSystemTransactions;